import React from "react";
import { Card } from "antd";
import LeadCard from "./LeadCard";

export default function LeadColumn({ title, leads }) {
  return (
    <Card title={title}>
      {leads.map((l) => (
        <LeadCard key={l.id} lead={l} />
      ))}
    </Card>
  );
}
